import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ThreadsPlaceholderIcon = (props: IconProps) => (
  <Icon width="362px" height="374px" viewBox="0 0 362 374" {...props}>
    <ellipse
      cx="180.359"
      cy="187.557"
      fill="#FFEACC"
      opacity=".4"
      rx="179.859"
      ry="179.765"
    />
    <mask
      id="a"
      width="21"
      height="20"
      x="74"
      y="63"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0463"
        height="18.9226"
        x="74.0029"
        y="63.4464"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M78.0492 115.762h46.0698V63.4464H78.0492c8.8365 0 16 7.1635 16 16v20.3155c0 8.8361-7.1634 16.0001-16 16.0001Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M94.0492 63.4464H353.333c4.418 0 8 3.5817 8 8v41.8806c0 4.419-3.582 8-8 8H102.049c-4.4181 0-7.9998-3.581-7.9998-8V63.4464Z"
    />
    <line
      x1="186.257"
      x2="341.514"
      y1="80.369"
      y2="80.369"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="113.868"
      x2="176.689"
      y1="80.369"
      y2="80.369"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="113.868"
      x2="341.514"
      y1="91.5"
      y2="91.5"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="113.868"
      x2="170.007"
      y1="103.744"
      y2="103.744"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <mask
      id="b"
      width="21"
      height="20"
      x="74"
      y="253"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0463"
        height="18.9226"
        x="74.0029"
        y="253.786"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M78.0492 306.101h46.0698v-52.315H78.0492c8.8365 0 16 7.163 16 16v20.315c0 8.837-7.1634 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M94.0492 253.786H353.333c4.418 0 8 3.581 8 8v41.881c0 4.418-3.582 8-8 8H102.049c-4.4181 0-7.9998-3.582-7.9998-8v-49.881Z"
    />
    <line
      x1="113.868"
      x2="207.872"
      y1="270.708"
      y2="270.708"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="218.554"
      x2="312.558"
      y1="270.708"
      y2="270.708"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="113.868"
      x2="341.514"
      y1="281.839"
      y2="281.839"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="113.868"
      x2="181.144"
      y1="294.083"
      y2="294.083"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <ellipse
      cx="98.5039"
      cy="309.44"
      fill="#FFBF66"
      rx="13.3642"
      ry="13.3571"
    />
    <path
      fill="#fff"
      d="M91.3578 315.284h2.5986v-7.792h-2.5986v7.792Zm14.2922-7.142c0-.715-.585-1.299-1.299-1.299h-4.1l.618-2.967.019-.208c0-.266-.11-.513-.286-.688l-.6884-.682-4.2746 4.279c-.2404.234-.3833.558-.3833.915v6.493c0 .715.5847 1.299 1.2993 1.299h5.847c.539 0 1-.325 1.195-.792l1.962-4.578c.059-.149.091-.305.091-.474v-1.298Z"
    />
    <mask
      id="c"
      width="21"
      height="20"
      x="-3"
      y="159"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="20.0463"
        height="18.9226"
        x="-2.84106"
        y="159.173"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.20522 211.488H47.2746v-52.315H1.2052c8.8366 0 16 7.163 16 16v20.315c0 8.837-7.1634 16-15.99998 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M17.2052 159.173H276.489c4.418 0 8 3.581 8 8v41.881c0 4.418-3.582 8-8 8H25.2052c-4.4183 0-8-3.582-8-8v-49.881Z"
    />
    <line
      x1="37.024"
      x2="231.259"
      y1="176.095"
      y2="176.095"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="152.847"
      x2="264.67"
      y1="187.226"
      y2="187.226"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="37.024"
      x2="141.051"
      y1="187.226"
      y2="187.226"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="37.024"
      x2="188.939"
      y1="199.47"
      y2="199.47"
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <ellipse
      cx="23.8872"
      cy="219.28"
      fill="#FFBF66"
      rx="13.3642"
      ry="13.3571"
    />
    <g clipPath="url(#d)">
      <path
        fill="#fff"
        d="M16.7411 225.123h2.5986v-7.791h-2.5986v7.791Zm14.2922-7.142c0-.714-.5847-1.299-1.2993-1.299h-4.0992l.6171-2.967.0195-.208c0-.266-.1104-.513-.2858-.688l-.6887-.682-4.2746 4.279c-.2404.234-.3833.559-.3833.916v6.493c0 .714.5847 1.298 1.2993 1.298h5.8468c.5392 0 1.0004-.324 1.1953-.792l1.962-4.577c.0584-.15.0909-.305.0909-.474v-1.299Z"
      />
    </g>
    <rect
      width="56.7977"
      height="20.0357"
      x="253.305"
      y="32.2798"
      fill="#FFBF66"
      rx="10.0179"
    />
    <ellipse
      cx="264.442"
      cy="42.2977"
      fill="#FFD599"
      rx="3.34103"
      ry="3.33929"
    />
    <ellipse
      cx="275.579"
      cy="42.2977"
      fill="#FFD599"
      rx="3.34103"
      ry="3.33929"
    />
    <ellipse
      cx="286.716"
      cy="42.2977"
      fill="#FFD599"
      rx="3.34103"
      ry="3.33929"
    />
    <ellipse
      cx="297.853"
      cy="42.2977"
      fill="#FFD599"
      rx="3.34105"
      ry="3.33929"
    />
    <defs>
      <clipPath id="d">
        <rect
          width="15.5915"
          height="15.5833"
          fill="#fff"
          transform="translate(16.0914 211.488)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ThreadsPlaceholderIcon);
